import { render } from "./CommentSlider.vue?vue&type=template&id=5852ab1d"
import script from "./CommentSlider.vue?vue&type=script&lang=js"
export * from "./CommentSlider.vue?vue&type=script&lang=js"

import "./CommentSlider.vue?vue&type=style&index=0&id=5852ab1d&lang=css"
script.render = render

export default script